import { ProfileInfo } from '@/features/profile/ProfileInfo'
import { Page } from '@/ui-kit'

const ProfileWebviewPage = () => {
  return (
    <Page>
      <div className="my-4">
        <ProfileInfo />
      </div>
    </Page>
  )
}

export default ProfileWebviewPage
